export const COLORS = {
    length: [
        { backgroundColor: '#F1F6FC', color: '#0f1941' },
        { backgroundColor: '#E4EEFA', color: '#0f1941' },
        { backgroundColor: '#C9DDF5', color: '#0f1941' },
        { backgroundColor: '#AFCDF1', color: '#0f1941' },
        { backgroundColor: '#95BCEC', color: '#0f1941' },
    ],
    formality: [
        { backgroundColor: '#DDFAFF', color: '#0f1941' },
        { backgroundColor: '#C5F5FE', color: '#0f1941' },
        { backgroundColor: '#ACF2FF', color: '#0f1941' },
        { backgroundColor: '#95EEFF', color: '#0f1941' },
    ],
    urgency: [
        { backgroundColor: '#FFFAF1', color: '#0f1941' },
        { backgroundColor: '#FEF4DC', color: '#0f1941' },
        { backgroundColor: '#FEEDC5', color: '#0f1941' },
        { backgroundColor: '#FEE2A4', color: '#0f1941' },
    ],
};
